import { PageType } from "@product/scmp-sdk";
import { useEffect } from "react";

import { config } from "scmp-app/data";
import { useExperiment } from "scmp-app/lib/optimizely";
import { setPianoCustomVariable } from "scmp-app/lib/rosetta";
import {
  DevelopmentInlinePaywallExperimentId,
  ProductionInlinePaywallExperimentId,
} from "scmp-app/lib/rosetta/a-b-test/paywall-instant-purchase/consts";

export const usePaywallInstantPurchaseABTest = (
  currentPageType: PageType,
  isRosettaSDKInitialized: boolean,
) => {
  const experimentId =
    config.general.env === "production"
      ? ProductionInlinePaywallExperimentId
      : DevelopmentInlinePaywallExperimentId;

  const { isExperimentActive, variant } = useExperiment(experimentId);

  useEffect(() => {
    if (
      !isRosettaSDKInitialized ||
      ![PageType.Article].includes(currentPageType) ||
      !isExperimentActive ||
      !variant
    )
      return;

    setPianoCustomVariable("abTestVariants.instantPurchase", {
      experimentId,
      variant,
    });
  }, [currentPageType, experimentId, isExperimentActive, isRosettaSDKInitialized, variant]);
};
